module.exports = __webpack_public_path__ + "img/10.05f92a3e.png";